import React from 'react';
import { Checkbox, Segmented, Space, Typography } from 'antd';
import { FULL_ADMIN_SCOPE, SCOPES } from '../../user/permissions';
import { OWNERSHIP_LABELS, scopesByArea } from './scopeSelection';

const { Text } = Typography;

const OWNERSHIP_OPTIONS = [
    { value: '', label: 'No' },
    { value: 'mine', label: `Yes, ${OWNERSHIP_LABELS.mine}` },
    { value: 'all', label: `Yes, ${OWNERSHIP_LABELS.all}` },
];

const ScopeRow = ({ id, value, onChange }) => {
    const { label, description, ownership } = SCOPES[id];
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
            <div>
                <Text strong>{label}</Text>
                <div><Text type="secondary">{description}</Text></div>
            </div>
            {ownership ? (
                <Segmented
                    size="small"
                    style={{ flexShrink: 0 }}
                    options={OWNERSHIP_OPTIONS}
                    value={value || ''}
                    onChange={(next) => onChange(id, next || undefined)}
                />
            ) : (
                <Checkbox checked={!!value} onChange={(e) => onChange(id, e.target.checked || undefined)} />
            )}
        </div>
    );
};

/** Edits a scope selection (`{ scopeId: 'mine' | 'all' | true }`), showing each scope's description. */
export const ScopesEditor = ({ selection, onChange }) => {
    const set = (id, value) => onChange({ ...selection, [id]: value });
    const isFullAdmin = !!selection[FULL_ADMIN_SCOPE];

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <ScopeRow id={FULL_ADMIN_SCOPE} value={selection[FULL_ADMIN_SCOPE]} onChange={set} />
            {!isFullAdmin && scopesByArea().map(([area, ids]) => (
                <div key={area}>
                    <Text type="secondary" style={{ textTransform: 'uppercase', fontSize: 12 }}>{area}</Text>
                    <Space direction="vertical" size="middle" style={{ width: '100%', marginTop: 8 }}>
                        {ids.map((id) => <ScopeRow key={id} id={id} value={selection[id]} onChange={set} />)}
                    </Space>
                </div>
            ))}
        </Space>
    );
};
